import PropTypes from 'prop-types';

import { BLOCK_TYPES, CLIENT_STATUS_SUPPORTED, CLIENT_STATUS_UNSUPPORTED } from './constants';

export const blockItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  labelId: PropTypes.string,
  textId: PropTypes.string,
  value: PropTypes.string
});

export const blockShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(BLOCK_TYPES).isRequired,
  titleId: PropTypes.string,
  textId: PropTypes.string,
  captionId: PropTypes.string,
  snippet: PropTypes.string,
  ordered: PropTypes.bool,
  items: PropTypes.arrayOf(blockItemShape),
  alternatives: PropTypes.arrayOf(PropTypes.string),
  hiddenForAuthMethod: PropTypes.string
});

export const sectionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  titleId: PropTypes.string,
  blocks: PropTypes.arrayOf(blockShape).isRequired
});

export const clientShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  icon: PropTypes.elementType,
  status: PropTypes.oneOf([CLIENT_STATUS_SUPPORTED, CLIENT_STATUS_UNSUPPORTED]).isRequired,
  authMethods: PropTypes.arrayOf(PropTypes.string).isRequired,
  summaryId: PropTypes.string,
  buildSections: PropTypes.func.isRequired
});
